import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ElementRegistryService<T> implements OnDestroy {

    private _elements$ = new BehaviorSubject<T[]>([]);
    public readonly elements$ = this._elements$.asObservable();
    public get elements() { return this._elements$.value };

    public register(element: T) {
        this.elements.push(element);
        this._elements$.next(this.elements);
    }

    public unregister(element: T) {
        const index = this.elements.indexOf(element);
        if (index == -1) return;
        this.elements.splice(index, 1);
        this._elements$.next(this.elements);
    }

    ngOnDestroy(): void {
        this._elements$.complete();
        this._elements$ = null;
    }

}